import { jsx as _jsx } from "react/jsx-runtime";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { bindTwitchAuth } from "../../hooks/useTwitchAuth";
import { SettingsProvider } from "./hooks/useSettings";
import { SleepingProvider } from "./hooks/useSleeping";
import App from "./App";
import "./globals.css";
bindTwitchAuth();
var root = createRoot(document.getElementById("root"));
root.render(_jsx(StrictMode, { children: _jsx(SettingsProvider, { children: _jsx(SleepingProvider, { children: _jsx(App, {}) }) }) }));
